import { Select, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Styles from './components.module.scss';
import { SelectProps } from 'antd/lib/select';
import { ReactNode } from 'react';

interface LabelAddon {
	label: string;
	required?: boolean;
	tooltip?: boolean;
	tooltipText?: string;
	addonRight?: ReactNode;
	addonRightClick?: any;
}

type BaseSelectProps = SelectProps<any> & {
	width?: string;
	labelConfig: LabelAddon;
};

export default function BaseSelect({ width, className, labelConfig, ...props }: BaseSelectProps) {
	const { label, required, tooltip, tooltipText, addonRight, addonRightClick } = labelConfig;

	return (
		<div style={width ? { width } : {}}>
			<div className={Styles.labelRow}>
				<div className={Styles.labelLeft}>
					<label className={Styles.inputLabel}>{label}</label>
					{required && <span className={Styles.required}>*</span>}
					{tooltip && (
						<Tooltip title={tooltipText || 'Informação adicional'}>
							<QuestionCircleOutlined className={Styles.tooltipIcon} rev={undefined} />
						</Tooltip>
					)}
				</div>
				{addonRight && (
					<span className={Styles.addonRight} style={{ cursor: addonRightClick ? 'pointer' : 'default' }} onClick={() => addonRightClick()}>
						{addonRight}
					</span>
				)}
			</div>
			<div className={Styles.inputWrapper}>
				<Select {...props} className={`${Styles.baseSelect} ${className ?? ''}`} dropdownClassName={Styles.baseSelectDropdown} bordered={false} />
			</div>
		</div>
	);
}
